/**
 * WalletCheckInteractionComingNext — placeholder state for the Trust &
 * Safety workflow which is not yet built. Keeps the bridge navigable.
 */
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { WalletShell, NAVY, GOLD } from "@/components/wallet/WalletShell";

export default function WalletCheckInteractionComingNext() {
  return (
    <WalletShell activeTab="institutions">
      <div className="max-w-2xl mx-auto px-4 lg:px-8 py-10 lg:py-16" data-testid="check-interaction-coming-next">
        <Link to="/wallet/institutions" className="inline-flex items-center gap-1.5 text-[12px] font-medium text-slate-500 hover:text-slate-800">
          <ArrowLeft className="w-3.5 h-3.5" /> Back
        </Link>
        <div className="mt-8 rounded-2xl border border-slate-100 bg-white p-8 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl flex items-center justify-center" style={{ background: `${GOLD}22` }}>
            <ShieldCheck className="w-7 h-7" style={{ color: NAVY }} />
          </div>
          <div className="mt-4 text-[10.5px] uppercase tracking-[0.24em] font-semibold" style={{ color: GOLD }}>Coming next</div>
          <h1 className="mt-1 font-display text-2xl font-semibold" style={{ color: NAVY }}>Check this interaction</h1>
          <p className="text-[13px] text-slate-600 mt-2 max-w-md mx-auto leading-relaxed">
            The Trust &amp; Safety workflow will compare a suspicious message, call, email or document against the trusted reference information Altara already holds for your relationship — institution identity, official channels, associated advisers and known Altara interactions.
          </p>
          <p className="text-[11.5px] text-slate-500 mt-3 max-w-md mx-auto">
            Not built yet — this bridge will connect here once Trust &amp; Safety is delivered.
          </p>
        </div>
      </div>
    </WalletShell>
  );
}
